/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React from "react";

import FitIcon from "@material-ui/icons/SettingsOverscan";
import DeleteIcon from "@material-ui/icons/Delete";

import MirrorHIcon from "@material-ui/icons/Flip";
import DublicateIcon from "@material-ui/icons/FileCopy";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import Switch from "@material-ui/core/Switch";

import ToolbarButton from "../ToolbarButton";
import SetPositionButton from "../SetPositionButton";

import { useStoreon } from "storeon/react";

import t from "../../translations";

const ImageButtons = ({ activeObject }) => {
  const { canvas, isAdmin, dispatch } = useStoreon("canvas", "isAdmin");
  const ao = activeObject;
  if (activeObject.mask && !activeObject.hasControls) {
    return null;
  }

  const isScalable = ao.scalable ? true : false;
  return (
    <React.Fragment>
      {isAdmin && (
        <React.Fragment>
          <Switch
            onClick={e => {
              ao.scalable = !ao.scalable;
              console.log(ao);
              console.log(ao.scalable);
              dispatch("activeObject/set", ao);
            }}
            checked={isScalable}
          />
          <ToolbarButton
            desc={"Dropzone"}
            tooltip
            icon={<CloudDownloadIcon />}
            onClick={() => {
              const maskColor = "#aaaa00";
              const defaultColor = "#aa00aa";
              if (!ao.mask) {
                ao.mask = true;
                ao.borderColor = maskColor;
                ao.cornerColor = maskColor;
                ao.snap = canvas.padding;
                ao.cornerStrokeColor = maskColor;
              } else {
                ao.mask = undefined;
                ao.borderColor = defaultColor;
                ao.cornerColor = defaultColor;
                ao.cornerStrokeColor = defaultColor;
                ao.snap = 0;
                ao.padding = 0;
              }
              canvas.requestRenderAll();
              dispatch("activeObject/set", ao);
            }}
          />
        </React.Fragment>
      )}
      {!activeObject.clipId && (
        <React.Fragment>
          <SetPositionButton
            canvas={canvas}
          />
          <ToolbarButton
            desc={t.dublicate}
            tooltip
            icon={<DublicateIcon />}
            onClick={() => {
              const obj = activeObject;
              obj.clone(cloned => {
                cloned.top += cloned.height * 0.2 * cloned.scaleY;
                cloned.left += cloned.width * 0.2 * cloned.scaleX;
                cloned.size = { ...obj.size };
                cloned.hash = obj.hash;
                cloned.thumb = obj.thumb;
                cloned.generateId();
                canvas.add(cloned);
                cloned.bringToFront();
                canvas.discardActiveObject();
                canvas.setActiveObject(cloned);
              });
            }}
          />
          <ToolbarButton
            desc={t.fit}
            tooltip
            icon={<FitIcon />}
            onClick={() => {
              activeObject && activeObject.fitToCutZone();
            }}
          />
        </React.Fragment>
      )}

      <ToolbarButton
        desc={t.mirrorV}
        tooltip
        wi
        icon={
          <MirrorHIcon
            css={css`
              transform: rotate(90deg);
            `}
          />
        }
        onClick={() => {
          ao.flipY = ao.flipY ? false : true;
          canvas.requestRenderAll();
        }}
      />
      <ToolbarButton
        desc={t.mirrorH}
        tooltip
        icon={<MirrorHIcon />}
        onClick={() => {
          ao.flipX = ao.flipX ? false : true;
          canvas.requestRenderAll();
        }}
      />

      <ToolbarButton
        desc={t.remove}
        tooltip
        icon={<DeleteIcon />}
        onClick={() => {
          canvas.remove(ao);
        }}
      />
    </React.Fragment>
  );
};

export default ImageButtons;
